"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminListingDetailsDtoListingStatusEnum = exports.AdminListingDetailsDtoCampaignEnum = exports.AdminListingDetailsDtoAuctionStatusEnum = exports.AdminListingDetailsDtoSaleTypeEnum = void 0;
exports.instanceOfAdminListingDetailsDto = instanceOfAdminListingDetailsDto;
exports.AdminListingDetailsDtoFromJSON = AdminListingDetailsDtoFromJSON;
exports.AdminListingDetailsDtoFromJSONTyped = AdminListingDetailsDtoFromJSONTyped;
exports.AdminListingDetailsDtoToJSON = AdminListingDetailsDtoToJSON;
exports.AdminListingDetailsDtoToJSONTyped = AdminListingDetailsDtoToJSONTyped;
var PropertyOwnerAdminDto_1 = require("./PropertyOwnerAdminDto");
var BackAccountDto_1 = require("./BackAccountDto");
var PropertyDocumentAdminDto_1 = require("./PropertyDocumentAdminDto");
var PropertyAgentAdminDto_1 = require("./PropertyAgentAdminDto");
var LocationDto_1 = require("./LocationDto");
/**
 * @export
 */
exports.AdminListingDetailsDtoSaleTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.AdminListingDetailsDtoAuctionStatusEnum = {
    ToBeStarted: 'to_be_started',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Cancelled: 'cancelled'
};
/**
 * @export
 */
exports.AdminListingDetailsDtoCampaignEnum = {
    VendorManaged: 'vendor_managed',
    UnreservedManaged: 'unreserved_managed'
};
/**
 * @export
 */
exports.AdminListingDetailsDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * Check if a given object implements the AdminListingDetailsDto interface.
 */
function instanceOfAdminListingDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('saleType' in value) || value['saleType'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('campaign' in value) || value['campaign'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('hideProperty' in value) || value['hideProperty'] === undefined)
        return false;
    if (!('displayPrice' in value) || value['displayPrice'] === undefined)
        return false;
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    if (!('location' in value) || value['location'] === undefined)
        return false;
    if (!('propertyDocuments' in value) || value['propertyDocuments'] === undefined)
        return false;
    if (!('offersAllowed' in value) || value['offersAllowed'] === undefined)
        return false;
    if (!('allowPrivateInspections' in value) || value['allowPrivateInspections'] === undefined)
        return false;
    if (!('enableAutoReply' in value) || value['enableAutoReply'] === undefined)
        return false;
    if (!('skipContractReview' in value) || value['skipContractReview'] === undefined)
        return false;
    return true;
}
function AdminListingDetailsDtoFromJSON(json) {
    return AdminListingDetailsDtoFromJSONTyped(json, false);
}
function AdminListingDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'publishedAt': json['publishedAt'] == null ? undefined : json['publishedAt'],
        'saleType': json['saleType'],
        'auctionStatus': json['auctionStatus'] == null ? undefined : json['auctionStatus'],
        'price': json['price'],
        'reservePrice': json['reservePrice'] == null ? undefined : json['reservePrice'],
        'auctionStartPrice': json['auctionStartPrice'] == null ? undefined : json['auctionStartPrice'],
        'bidIncrement': json['bidIncrement'] == null ? undefined : json['bidIncrement'],
        'intervalSpanInMinutes': json['intervalSpanInMinutes'] == null ? undefined : json['intervalSpanInMinutes'],
        'campaign': json['campaign'],
        'auctionStartDate': json['auctionStartDate'] == null ? undefined : json['auctionStartDate'],
        'reverseAuctionDecreaseAmount': json['reverseAuctionDecreaseAmount'] == null ? undefined : json['reverseAuctionDecreaseAmount'],
        'reverseAuctionNextDecreaseAt': json['reverseAuctionNextDecreaseAt'] == null ? undefined : json['reverseAuctionNextDecreaseAt'],
        'listingStatus': json['listingStatus'],
        'hideProperty': json['hideProperty'],
        'displayPrice': json['displayPrice'],
        'slug': json['slug'],
        'defaultTemplateId': json['defaultTemplateId'] == null ? undefined : json['defaultTemplateId'],
        'bankAccount': json['bankAccount'] == null ? undefined : (0, BackAccountDto_1.BackAccountDtoFromJSON)(json['bankAccount']),
        'location': (0, LocationDto_1.LocationDtoFromJSON)(json['location']),
        'propertyDocuments': (json['propertyDocuments'].map(PropertyDocumentAdminDto_1.PropertyDocumentAdminDtoFromJSON)),
        'propertyAgents': json['propertyAgents'] == null ? undefined : (json['propertyAgents'].map(PropertyAgentAdminDto_1.PropertyAgentAdminDtoFromJSON)),
        'propertyOwners': json['propertyOwners'] == null ? undefined : (json['propertyOwners'].map(PropertyOwnerAdminDto_1.PropertyOwnerAdminDtoFromJSON)),
        'coVendors': json['coVendors'] == null ? undefined : (json['coVendors'].map(PropertyOwnerAdminDto_1.PropertyOwnerAdminDtoFromJSON)),
        'offersAllowed': json['offersAllowed'],
        'allowPrivateInspections': json['allowPrivateInspections'],
        'enableAutoReply': json['enableAutoReply'],
        'skipContractReview': json['skipContractReview'],
    };
}
function AdminListingDetailsDtoToJSON(json) {
    return AdminListingDetailsDtoToJSONTyped(json, false);
}
function AdminListingDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'publishedAt': value['publishedAt'],
        'saleType': value['saleType'],
        'auctionStatus': value['auctionStatus'],
        'price': value['price'],
        'reservePrice': value['reservePrice'],
        'auctionStartPrice': value['auctionStartPrice'],
        'bidIncrement': value['bidIncrement'],
        'intervalSpanInMinutes': value['intervalSpanInMinutes'],
        'campaign': value['campaign'],
        'auctionStartDate': value['auctionStartDate'],
        'reverseAuctionDecreaseAmount': value['reverseAuctionDecreaseAmount'],
        'reverseAuctionNextDecreaseAt': value['reverseAuctionNextDecreaseAt'],
        'listingStatus': value['listingStatus'],
        'hideProperty': value['hideProperty'],
        'displayPrice': value['displayPrice'],
        'slug': value['slug'],
        'defaultTemplateId': value['defaultTemplateId'],
        'bankAccount': (0, BackAccountDto_1.BackAccountDtoToJSON)(value['bankAccount']),
        'location': (0, LocationDto_1.LocationDtoToJSON)(value['location']),
        'propertyDocuments': (value['propertyDocuments'].map(PropertyDocumentAdminDto_1.PropertyDocumentAdminDtoToJSON)),
        'propertyAgents': value['propertyAgents'] == null ? undefined : (value['propertyAgents'].map(PropertyAgentAdminDto_1.PropertyAgentAdminDtoToJSON)),
        'propertyOwners': value['propertyOwners'] == null ? undefined : (value['propertyOwners'].map(PropertyOwnerAdminDto_1.PropertyOwnerAdminDtoToJSON)),
        'coVendors': value['coVendors'] == null ? undefined : (value['coVendors'].map(PropertyOwnerAdminDto_1.PropertyOwnerAdminDtoToJSON)),
        'offersAllowed': value['offersAllowed'],
        'allowPrivateInspections': value['allowPrivateInspections'],
        'enableAutoReply': value['enableAutoReply'],
        'skipContractReview': value['skipContractReview'],
    };
}
